const ConfigurationFactory = require("../ConfigurationFactory");
const PlayerIntegration = require("./PlayerIntegration");

const service = {};

const receiveBrightSignMessages = ()=>{
  window.addEventListener("message", msg=>{
    if (!msg || msg.origin !== location.origin || !msg.data || msg.data.to !== "viewer" || msg.data.from !== "brightsign") {return;}

    console.log("Received message from BrightSign", msg);

    if (msg.data.topic === "screenshot-success") {
      console.log("Sending Saved");
      PlayerIntegration.sendScreenshotSaved(msg.data.clientId)
    }

    if (msg.data.topic === "screenshot-failure") {
      console.log("Sending Failed");
      PlayerIntegration.sendScreenshotFailed(msg.data.clientId)
    }
  });
};

service.init = () => {
  console.log("Initializing BrightSign messaging");

  receiveBrightSignMessages();
};

module.exports = service;
